
import EventCard from "./EventCard"
import "./Event.css"
import EventImage1 from "../assets/Events/1.jpg"
import EventImage2 from "../assets/Events/2.jpg"
import EventImage3 from "../assets/Events/3.png"
import EventImage4 from "../assets/Events/4.png"

const events = [
  {
    title: "Qbit Ideathon",
    start: "Mar 21, 2025 12:00 PM",
    end: "Mar 28, 2025 05:00 PM",
    status: "old",
    registered: true,
    location: "NSUT EAST CAMPUS",
    image: EventImage1,
    link: "https://unstop.com/p/qbit-ideathon-netaji-subhas-university-of-technology-nsut-delhi-1445581",
  },
 
  {
  title: "Freshers Orientation 2025",
  start: "2025-08-06 08:00 AM",  // 6 August 2025
  end: "2025-08-06 11:00 AM",
  status: "upcoming",
  registered: true,
  location: "Offline Events",
  image: EventImage2,
  link: "https://forms.office.com/r/64BeTJ1UyJ",
},

  {
    title: "Nimantran",
    start: "2025-08-05 12:00 AM",
    end: "2025-08-06 11:59 AM",
    status: "upcoming",
    registered: true,
    location: "NSUT EAST CAMPUS",
    image: EventImage3,
    link: "#",
  },
  {
    title: "Generative AI",
    start: "2025-06-19 12:00 AM",
    end: "2025-06-21 11:59 AM",
    status: "old",
    registered: true,
    location: "NSUT EAST CAMPUS",
    image: EventImage4,
    link: "#",
  },
]

function Event() {
  return (
    <div className="event-bg">
  {/* Drone container with absolute positioning */}

  {/* Main content */}
  <div className="event-container">
    <h1 className="event-main-title">Our Events</h1>
    <div className="event-list">
      {events.map((event, idx) => (
        <EventCard event={event} key={idx} />
      ))}
    </div>
  </div>
</div>

  )
}

export default Event
